import CropFields from "./crop_fields";
import Producers from "./producers";
import QueryProducers from "./query_producers";

export default [
  ...CropFields,
  ...Producers,
  ...QueryProducers
];
